import { getData, postData, downDataNew } from "@/assets/js/api.js";
//获取监控方案显示数据
export const GetMonitorSolutionData = (params, fn) => {
  let methods = "/api/Monitor/GetMonitorSolutionData";
  getData(methods, params, 1, fn);
};
//国内的项目 大数据统计的项目数据  上面的GetMonitorSolutionData是欧洲使用的老接口
export const GetProjectEnergyConsumption = (params, fn) => {
  let methods = "/businessapi/Stat/GetProjectEnergyConsumption";
  return getData(methods, params, 1, fn);
}
//更新监控卡片
export const UpdateMonitorCard = (params, fn) => {
  let methods = "/api/Monitor/UpdateMonitorCard";
  postData(methods, params, 1, fn);
};

export const GetMonitorWeather = (params, fn) => {
  let methods = "/api/Project/GetWeather";
  getData(methods, params, 1, fn);
  // getData('', params, 0, fn, '',"https://free-api.heweather.net/s6/weather/now?location=shanghai&key=c28a2b4a1fc14bfca9951fd0eb312b02");
};

export const GetMonitorLedWeather = (params, fn) => {
  let methods = "/api/Led/QueryWeather";
  getData(methods, params, 1, fn);
};

// 批量关联
export const AddDeviceRelation = (params, fn) => {
  let methods = "/api/Led/AddDeviceRelation";
  return postData(methods, params, 1, fn);
};

// 查询关联
export const GetRelationDeviceList = (params, fn) => {
  let methods = "/api/Led/GetRelationDeviceList";
  return postData(methods, params, 1, fn);
};
// 查询关联场景
export const GetRelationSceneList = (params, fn) => {
  let methods = "/api/Led/GetRelationSceneList";
  return postData(methods, params, 1, fn);
};
//查询关联场景跟设备
export const GetRelationDeviceAndSceneList = (params, fn) => {
  let methods = "/api/Led/GetRelationDeviceAndSceneList";
  return getData(methods, params, 1, fn);
};

//关联的场景设备排序
export const SetRelationSort = (params, fn) => {
  let methods = "/api/Led/SetRelationSort";
  return postData(methods, params, 1, fn);
};

// 获取关联场景跟设备
export const FindDeviceAndSceneListByCommandValue = (params, fn) => {
  let methods = "/api/Led/GetDeviceAndSceneListByCommandValue";
  return postData(methods, params, 1, fn);
}

export const GetClassskuList = () => {
  return getData(`/baseservice/ClassSku/GetList`, {}, 1)
}

// 新增classsku筛选设备报错
export const GetDeviceListByPage = (params, fn) => {
  let methods = "/api/Led/GetDeviceListByPage";
  return getData(methods, params, 1, fn);
};

// 批量解除关联
export const RemoveDeviceRelation = (params, fn) => {
  let methods = "/api/Led/RemoveDeviceRelation";
  return postData(methods, params, 1, fn);
};

//导出区域实时能耗折线图
export const ExprotEnergyData = (params, that, info, fn) => {
  let methods = "/api/StatisticalAnalysis/ExprotEnergyData";
  // getData(methods, params, 2, fn);
  downDataNew(
    methods,
    params,
    that,
    info,
    "?projectCode=" +
      params.projectCode +
      "&gpNo=" +
      params.gpNo +
      "&gpName=" +
      params.gpName +
      "&cardCode=" +
      params.cardCode +
      "&chartTimeType=" +
      (params.chartTimeType != null ? params.chartTimeType : "") +
      (params.count != null ? "&count=" + params.count : "")
  );
};

// 获取系统的能源统计分类
export const GetSystemEnergyTypeList = (params, fn) => {
  const methods = "/businessapi/Stat/GetSystemEnergyTypeList";
  getData(methods, params, 1, fn);
};
// 获取能源表数据
export const GetEnergyStatsList = (params, fn) => {
  const methods = "/businessapi/Stat/GetAreaEnergyStatsList";
  return postData(methods, params, 1, fn);
};

//
//批量获取饼图数据
export const GetMultipleAreaEnergyStatsList =  (params, fn) => {
  const methods = "/businessapi/Stat/GetMultipleAreaEnergyStatsList";
  return postData(methods, params, 1, fn);
};

// 添加项目的能耗统计分类
export const addOrUpdateEnergyTypeList = (params, fn) => {
  const methods = "/businessapi/Stat/AddOrUpdateEnergyTypeList";
  postData(methods, params, 1, fn);
};

//添加项目的能耗定量
export const addOrUpdateEnergySettingList = (params, fn) => {
  const methods = "/businessapi/Stat/AddOrUpdateEnergySettingList";
  postData(methods, params, 1, fn);
};

//获取项目的能耗定量
export const getEnergySettingList = (params, fn) => {
  const methods = "/businessapi/Stat/GetEnergySettingList";
  getData(methods, params, 1, fn);
};

//导出能耗统计表格
export const ExprotEnergyStatsData = (params, fn) => {
  const methods = "/businessapi/Stat/ExprotUserEnergyStatsData";
  postData(methods, params, 1, fn);
};

//获取项目的在线设备/故障设备 （新接口）
export const GetMonitorSolutionDataFormat = (params, fn) => {
  const methods = "/api/Monitor/GetMonitorSolutionDataFormat";
  getData(methods, params, 1, fn);
};

//获取节能或者能耗排行榜
export const GetPagedEnergyStatsRank = ({pageSize,pageIndex,...params}, fn) => {

  const methods = "/businessapi/Stat/GetPagedEnergyStatsRank?pageSize="+pageSize+"&pageIndex="+pageIndex;
  postData(methods, params, 1, fn);
};

//保存排行榜修改的参数配置
export const UpdateDashboardRankModule = (params, fn) => {
  const methods = "/businessapi/Stat/UpdateDashboardRankModule";
  postData(methods, params, 1, fn);
};

//排行榜参数配置
export const GetDashboardModuleList = (params, fn) => {
  const methods = "/businessapi/Stat/GetDashboardModuleList";
  getData(methods, params, 1, fn);
};

//获取系统信息-cpu 内存 磁盘
export const GetSystemInfo = (params, fn) => {
  const methods = "/businessapi/Stat/GetSystemInfo";
  getData(methods, params, 1, fn);
};

//获取项目所有计量设备-电表
export const GetMeteringDeviceList = (params, fn) => {
  const methods = "/api/device/GetMeteringDeviceList";
  getData(methods, params, 1, fn);
};

//获取项目已绑定区域的电表
export const GetMeteringDeviceConfigList = (params, fn) => {
  const methods = "/businessapi/Stat/GetMeteringDeviceConfigList";
  getData(methods, params, 1, fn);
};

//保存项目区域绑定的电表
export const AddOrUpdateAreaMeteringDeviceConfigs = (params, fn) => {
  const methods = "/businessapi/Stat/AddOrUpdateAreaMeteringDeviceConfigs";
  postData(methods, params, 1, fn);
};
/**
 * 地图监控-能源管理
 * @param {Object} params 
 * @param {number} params.pageSize 10
 * @param {number} params.pageIndex 1
 * @param {number} params.GpNo
 * @param {string} params.DataType 'MonthOnMonth'
 * @param {string} params.StartTime 开始时间
 * @param {string} params.StatsType '0'
 * @param {number} params.TimeType 2:日, 3:周, 4:月, 5:年
 */
export const getPagedEnergyStatsRank_monitor = (params = {}) => {
  const { pageSize = 10, pageIndex = 1, ...rest} = params
  const methods = "/businessapi/Stat/GetPagedEnergyStatsRank?pageSize="+pageSize+"&pageIndex="+pageIndex;
  return postData(methods, rest, 1);
}

/**
 * 碳排放因子配置--获取项目配置碳排放因子情况
 *  1. 如果GasEmissionFactorCountryCode != null， 显示国家按钮
  * 2. 如果GasEmissionFactorCountryCode == null   显示手动输入碳排放因子
 * @param {*} params 
 * @param {*} fn 
 */
export const GetCarbonEmissionConfig = (params, fn) => {
  const { projectcode, ...rest} = params
  const methods = "/api/project/get?projectcode=" + projectcode;
  return getData(methods, rest, 1, fn);
}
/**
 * 碳排放因子配置--更新
 * @param {*} params 
 * @param {*} fn 
 */
export const UpdateCarbonEmissionConfig = (params, fn) => {
  const methods = "/api/project/put";
  postData(methods, params, 1, fn);
}
/**
 * 碳排放因子配置--获取国家
 * @param {*} params 
 * @param {*} fn 
 */
export const GetGasEmissionFactorList = (params, fn) => {
  const methods = "/api/project/GetGasEmissionFactorList";
  return getData(methods, params, 1, fn);
}

/**
 * 增加或修改用户能耗导出配置
 * @param {*} params 
 * @param {*} fn 
 * @returns 
 */
export const AddOrUpdateEnergyExportSetting = (params, fn) => {
  const methods = "/businessapi/Stat/AddOrUpdateEnergyExportSetting";
  return postData(methods, params, 1, fn);
}
/**
 * 获取用户能耗导出配置
 * @param {*} params 
 * @param {*} fn 
 * @returns 
 */
export const GetEnergyExportSetting = (params, fn) => {
  const methods = "/businessapi/Stat/GetEnergyExportSetting";
  return getData(methods, params, 1, fn);
}
/**
 * 能耗导出接口
 * @param {*} params 
 * @param {*} fn 
 * @returns 
 */
export const ExportUserEnergyReport = (params, fn) => {
  const methods = "/businessapi/Stat/ExportUserEnergyReport";
  return postData(methods, params, 1, fn);
}

//添加或者修改项目的阶梯电价
export const AddOrUpdatePowerTariffConfig = (params,fn) => {
	let methods = '/businessapi/stat/AddOrUpdatePowerTariffConfig';
	return postData(methods, params, 1, fn);
};

//获取项目的阶梯电价列表
export const GetPowerTariffConfigList = (params,fn) => {
	let methods = '/businessapi/stat/GetPowerTariffConfigList';
	return getData(methods, params, 1, fn);
};
